import { defineMessages } from 'react-intl';

const messages: {
	emptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pageNotFoundImageAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	pageNotFoundImageAriaLabel: {
		defaultMessage: 'Page not found',
		id: 'embedded-confluence-common.src.content.page-not-found-image.aria-label',
		description: 'The aria label for the page not found image',
	},
	emptyStateHeader: {
		defaultMessage: "We couldn't find what you're looking for",
		id: 'embedded-confluence-common.src.content.empty-state-header',
		description:
			'The header message in the empty state error screen shown to the user when there is no page to render',
	},
	emptyStateDescription: {
		defaultMessage:
			"We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it 😉",
		id: 'embedded-confluence-common.src.content.empty-state-description',
		description:
			'The description message in the empty state error screen shown to the user when there is no page to render',
	},
});
export default messages;
